import keys from '@debbie/common/dist/cache/keys.js';
import { SecondaryEmailType, } from '@debbie/common/dist/customers/index.js';
import { Site, validateEmail } from '@debbie/common/dist/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as customersAPI from '@debbie/cortex/dist/api/customers.js';
import { useCosmoV2ProviderSubscriptions } from '@debbie/cortex/dist/cosmoV2/index.js';
import { customersEntity, ensureCustomerLoaded, } from '@debbie/cortex/dist/customers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import { errorNotification } from '../../../utils/errors.js';
import Button from '../../Button.js';
import ButtonGroup from '../../ButtonGroup.js';
import Checkbox from '../../Checkbox.js';
import { Mail, PlusCircle } from '../../Icons/index.js';
import Input from '../../Input.js';
import Modal from '../../Modal.js';
import Well from '../../Well.js';
import SecondaryEntity from './SecondaryEntity.js';
import UserInfoEntity from './UserInfoEntity.js';
const UserEmail = (props) => {
    const { details } = props.user;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const [addSecondaryEmail, setAddSecondaryEmail] = useState(false);
    const [secondaryEmail, setSecondaryEmail] = useState('');
    const [secondaryEmailNote, setSecondaryEmailNote] = useState('');
    const [secondaryEmailType, setSecondaryEmailType] = useState(SecondaryEmailType.CC);
    const addSecondaryEmailMutation = useMutation(async () => {
        await customersAPI.addEventToUser(props.user.customerId, props.user.userId, {
            type: 'addSecondaryEmail',
            details: {
                id: crypto.randomUUID(),
                email: secondaryEmail,
                note: secondaryEmailNote,
                enabled: true,
                type: secondaryEmailType,
            },
        });
        q.invalidate(keys.write.modify(customersEntity, props.user.customerId));
        await ensureCustomerLoaded(props.user.customerId);
    }, {
        onSuccess: () => {
            setSecondaryEmail('');
            setSecondaryEmailNote('');
            setSecondaryEmailType(SecondaryEmailType.CC);
            setAddSecondaryEmail(false);
        },
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.email);
        },
    });
    const patchEmail = useMutation((email) => props.patchUser({ email }), {
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.email);
        },
    });
    const emailValidation = details &&
        details.emailValidations &&
        details.emailValidations.find((eV) => eV.address === details.email);
    const loader = useCosmoV2ProviderSubscriptions(props.user.userId);
    const providerSubscriptions = h.hasData(loader) ? loader.data : null;
    const isSubscribedToCosmo = providerSubscriptions && providerSubscriptions.length > 0;
    const tags = []
        .concat(emailValidation && emailValidation.didYouMean
        ? {
            content: `${lang.emailValidations.didYouMean}: ${emailValidation.didYouMean}`,
        }
        : [])
        .concat(emailValidation && emailValidation.isRoleAddress
        ? { content: lang.emailValidations.isRoleAddress }
        : [])
        .concat(emailValidation && emailValidation.isDisposableAddress
        ? { content: lang.emailValidations.isDisposableAddress }
        : [])
        .concat(emailValidation &&
        emailValidation.risk &&
        !['low'].includes(emailValidation.risk)
        ? {
            content: `${lang.emailValidations.risk}: ${lang.emailValidations[emailValidation.risk] ||
                emailValidation.risk}${emailValidation.reason ? ' - ' : ''}${emailValidation.reason
                .map((r) => lang.emailValidations[r] || r)
                .join(', ')}`,
            theme: THEME.WARNING,
        }
        : []);
    return (React.createElement(React.Fragment, null,
        React.createElement(UserInfoEntity, { tags: tags, title: lang.debtorInfo.email, value: details.email, hist: details.emailHist, onChange: (val) => patchEmail.mutate(val), nextToInfo: isSubscribedToCosmo && site === Site.Caseworker ? (React.createElement("div", { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.customers.addSecondaryEmails, onClick: () => setAddSecondaryEmail(!addSecondaryEmail), style: { display: 'inline-block', marginRight: '5px' } },
                React.createElement(PlusCircle, { style: { cursor: 'pointer' } }))) : undefined, renderValue: (value) => {
                return ((value && (React.createElement(React.Fragment, null,
                    React.createElement("a", { href: `mailto:${value}`, style: { color: 'inherit' } },
                        React.createElement(Mail, { style: { margin: '.2em .3em -.2em  0px' } }),
                        " ",
                        value)))) || (React.createElement("span", { style: { opacity: 0.5 } }, lang.debtorInfo.noEmailAddr)));
            }, removable: true }),
        props.user.details.secondaryEmails && (React.createElement("div", null,
            props.user.details.secondaryEmails.map((secondaryEmail) => (React.createElement(SecondaryEmail, { key: secondaryEmail.id, secondaryEmail: secondaryEmail, user: props.user }))),
            React.createElement("br", null))),
        addSecondaryEmail && (React.createElement(React.Fragment, null,
            React.createElement(Well, null,
                React.createElement(EmailTypeEditor, { type: secondaryEmailType, onChange: (type) => setSecondaryEmailType(type) }),
                React.createElement(Input, { placeholder: lang.customers.note, value: secondaryEmailNote, onChange: (e) => setSecondaryEmailNote(e.target.value) }),
                React.createElement(Input, { placeholder: lang.debtorInfo.email, value: secondaryEmail, onChange: (e) => setSecondaryEmail(e.target.value) }),
                React.createElement(Button, { size: "small", loading: addSecondaryEmailMutation.isLoading, onClick: () => addSecondaryEmailMutation.mutate(), block: true, disabled: !validateEmail(secondaryEmail) }, lang.customers.addSecondaryEmail)),
            React.createElement("br", null)))));
};
export default UserEmail;
const SecondaryEmail = (props) => {
    const { email, type, enabled, id, note } = props.secondaryEmail;
    const lang = useSelector((s) => s.lang);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [_note, setNote] = useState(note);
    const [_email, setEmail] = useState(email);
    const [_enabled, setEnabled] = useState(enabled);
    const [_type, setType] = useState(type);
    const patchSecondaryEmailMutation = useMutation(async () => {
        await customersAPI.addEventToUser(props.user.customerId, props.user.userId, {
            type: 'patchSecondaryEmail',
            details: {
                id,
                ...(email !== _email ? { email: _email } : {}),
                ...(note !== _note ? { note: _note } : {}),
                ...(enabled !== _enabled ? { enabled: _enabled } : {}),
                ...(type !== _type ? { type: _type } : {}),
            },
        });
        q.invalidate(keys.write.modify(customersEntity, props.user.customerId));
        await ensureCustomerLoaded(props.user.customerId);
    }, {
        onSuccess: () => {
            setEditModalOpen(false);
        },
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.email);
        },
    });
    return (React.createElement(SecondaryEmailStyled, null,
        React.createElement(SecondaryEntity, { toggleEditModal: () => setEditModalOpen(!editModalOpen), deleteEventType: "deleteSecondaryEmail", id: id, note: note || '', user: props.user, enabled: enabled, render: React.createElement(React.Fragment, null,
                React.createElement("div", { style: {
                        fontWeight: 900,
                        fontSize: '0.7em',
                        cursor: 'pointer',
                        color: THEME.COLOR_ACCENT,
                    } }, type),
                email) }),
        editModalOpen && (React.createElement(Modal, { maxWidth: "500px", onToggle: () => setEditModalOpen(!editModalOpen) },
            React.createElement(EmailTypeEditor, { type: _type, onChange: (type) => setType(type) }),
            React.createElement(Checkbox, { placeholder: lang.customers.enabled, checked: _enabled, onChange: (e) => setEnabled(e.target.checked) }),
            React.createElement(Input, { placeholder: lang.customers.note, value: _note || '', onChange: (e) => setNote(e.target.value) }),
            React.createElement(Input, { placeholder: lang.debtorInfo.email, value: _email, onChange: (e) => setEmail(e.target.value) }),
            React.createElement(Button, { disabled: !((email !== _email ||
                    note !== _note ||
                    enabled !== _enabled ||
                    type !== _type) &&
                    validateEmail(_email)), block: true, onClick: () => patchSecondaryEmailMutation.mutate(), loading: patchSecondaryEmailMutation.isLoading }, lang.customers.save)))));
};
const SecondaryEmailStyled = styled.div `
  margin-bottom: 8px;
`;
const EmailTypeEditor = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { size: "mini", onClick: () => props.onChange(SecondaryEmailType.To), theme: props.type === SecondaryEmailType.To ? undefined : 'secondary' }, "TO"),
            React.createElement(Button, { size: "mini", onClick: () => props.onChange(SecondaryEmailType.CC), theme: props.type === SecondaryEmailType.CC ? undefined : 'secondary' }, "CC"),
            React.createElement(Button, { size: "mini", onClick: () => props.onChange(SecondaryEmailType.BCC), theme: props.type === SecondaryEmailType.BCC ? undefined : 'secondary' }, "BCC")),
        React.createElement("br", null),
        React.createElement("br", null)));
};
//# sourceMappingURL=UserEmail.js.map